// A missing price is not zero. Accept explicit decimal input without guessing grouping.
export function parseResourceReferencePrice(input: string): number | null {
  const text = input.trim();
  if (!/^\d+(?:[.,]\d+)?$/.test(text)) return null;
  const value = Number(text.replace(",", "."));
  return Number.isFinite(value) && value >= 0 && value <= 1e9 ? value : null;
}
